import imageCompression from "browser-image-compression";

/**
 * يضغط الصورة في المتصفّح قبل رفعها إلى Storage.
 * - يتجاهل الفيديوهات وغير الصور (يُرجعها كما هي).
 * - أقصى أبعاد 1920 بكسل، جودة ~0.82، ويفضّل WebP عند الدعم.
 * - يُرجع الملفّ الأصليّ في حال فشل الضغط (آمن).
 */
export type CompressOptions = {
  maxSizeMB?: number;
  maxWidthOrHeight?: number;
  initialQuality?: number;
};

/** إعدادات صور الهيرو/الخلفيات الممتدّة بعرض الشاشة — جودة أعلى لتفادي التبكسل على شاشات Retina. */
export const HERO_COMPRESS_OPTIONS: CompressOptions = {
  maxSizeMB: 2,
  maxWidthOrHeight: 2560,
  initialQuality: 0.9,
};

export async function compressImageBeforeUpload(
  file: File,
  options: CompressOptions = {},
): Promise<File> {
  if (!file || !file.type.startsWith("image/")) return file;
  // GIF متحرّك: لا تلمسه (الضغط يكسر الحركة).
  if (file.type === "image/gif") return file;

  try {
    const supportsWebp =
      typeof document !== "undefined" &&
      document.createElement("canvas").toDataURL("image/webp").startsWith("data:image/webp");

    const compressed = await imageCompression(file, {
      maxSizeMB: options.maxSizeMB ?? 0.5,
      maxWidthOrHeight: options.maxWidthOrHeight ?? 1920,
      initialQuality: options.initialQuality ?? 0.82,
      useWebWorker: true,
      fileType: supportsWebp ? "image/webp" : undefined,
    });

    // إن أصبح أكبر بالغفلة، أعِد الأصل.
    if (compressed.size >= file.size) return file;

    const baseName = file.name.replace(/\.[^.]+$/, "");
    const ext = supportsWebp ? "webp" : (file.name.split(".").pop() || "jpg");
    return new File([compressed], `${baseName}.${ext}`, {
      type: compressed.type || file.type,
      lastModified: Date.now(),
    });
  } catch {
    return file;
  }
}
